const { BUSINESS_MODELS } = require("../../constants");

const getCarteGriseConfig = (
  journeyType,
  appConfig,
  businessModel,
  isB2BLeasysSelected
) => {
  const { configuration } = appConfig;
  const isB2B = businessModel === BUSINESS_MODELS.B2B;

  const carteGrise = isB2B
    ? configuration.app.solJourney.b2b[journeyType]?.carteGrise
    : configuration.app.solJourney[journeyType]?.carteGrise;

  if (carteGrise?.enabled && isB2B && isB2BLeasysSelected) {
    const { keyAccount } = configuration.app;

    if (!keyAccount?.carteGriseEnabled) {
      return { ...carteGrise, enabled: false };
    }
  }

  return carteGrise;
};

module.exports = { getCarteGriseConfig };
